<template>
  <div>
    <v-container fluid>
      <v-card class="card2">
        <v-row style="border-bottom: 1px solid #c9c9c9;">
          <v-col cols="12" md="6">
            <h1 style="font-weight: 600;" class="ml-4">{{TitleName}}</h1>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <!-- Stepper -->
        <v-stepper class="mt-4 custom-stepper" alt-labels style="box-shadow: none!important;" show-actions>
          <v-stepper-header style="box-shadow: none!important;" class="customstep-header">
            <v-stepper-item :complete="step > 1" step="1" value="1" title="Basic Information" />
            <v-img :src="images.dividerImg" v-if="step == 1"></v-img>
            <v-img :src="images.dividercompleteImg" v-if="step == 2"></v-img>
            <v-stepper-item :complete="step > 2" step="2" value="2" title="Document Setting" />
          </v-stepper-header>

          <v-stepper-window v-model="step">
            <!-- STEP 1 -->
            <v-stepper-window-item value="1">
              <v-form class="mt-4" ref="formStep1">
                <v-row>
                  <v-col cols="12" md="8">
                        <label class="input-label">Document Name</label><span class="required">* </span>
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoVectorDatabaseName") }}</span>
                            </v-tooltip>
                        <v-text-field id="documentname-field-uploadvector" @keypress="handleKeypress"
                          @paste="handlePaste" :error="!!errors.documentNameError" :error-messages="errors.documentNameError" :rules="[rules.required]" :disabled="actionEdit"
                          v-model="searchVectorDBName2" variant="outlined" density="compact" hide-details="auto"
                          placeholder="Document name" class="modern-input">
                        </v-text-field>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="12">
                    <h3 style="font-weight: bold;"> Document Type & Processing</h3>
                  </v-col>
                  <v-col cols="12" md="4">
                      <label class="input-label">Document Type</label> <span class="required">* </span> 
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoDoctype") }}</span>
                            </v-tooltip>
                        <v-select id="doctype-select-uploadvector" :error="!!errors.doctypeError" placeholder="Document Type"
                          :error-messages="errors.doctypeError" :rules="[rules.required]" :items="datadoctype"
                          item-title="name" item-value="value" variant="outlined" density="compact" hide-details="auto"
                          v-model="doctype" return-object @update:model-value="setTypeFile(doctype.value)" class="modern-input">
                          <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" :id="'doctype-option-' + item.raw.id" :value="item.raw.value">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <label class="input-label">{{ $t('vectortype') }}</label> <span class="required">* </span> 
                      <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoVectortype") }}</span>
                        </v-tooltip>
                        <v-select id="vectortype-select-uploadvector" :error="!!errors.vectortypeError"
                          :error-messages="errors.vectortypeError" :rules="[rules.required]" :placeholder="$t('vectortype')"
                          :items="filterdatavectortype" item-title="name" item-value="value" variant="outlined" class="modern-input"
                          density="compact" hide-details="auto" v-model="vectortype" return-object>
                          <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" :id="'vectortype-option-' + item.raw.id"
                              :value="item.raw.value">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <label class="input-label">Processing Method</label> <span class="required">* </span> 
                      <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfofillterModelType") }}</span>
                            </v-tooltip>
                        <v-autocomplete id="type-autocomplete-uploadvector" :error="!!errors.modelTypeError"
                          :error-messages="errors.modelTypeError" :items="filterDDType" item-title="name" placeholder="Processing Method"
                          item-value="value" clearable variant="outlined" density="compact" hide-details="auto" class="modern-input"
                          :rules="[rules.required]" v-model="requestVector.modelType">
                          <template v-slot:item="{ props, item }">
                            <v-list-item :id="'processing-method-option-' + item.raw.id" :value="item.raw.value"
                              v-bind="props" :title="item.raw.name" class="processing-item">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                              <template v-slot:append>
                                <v-tooltip location="right" max-width="400px">
                                  <template v-slot:activator="{ props }">
                                    <v-icon v-bind="props" size="small"
                                      class="help-icon">mdi-information-outline</v-icon>
                                  </template>
                                  <div class="tooltip-image">
                                    <img :src="item.raw.image" width="300" />
                                  </div>
                                </v-tooltip>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="4" v-show="requestVector.modelType == 3">
                    
                      <label class="input-label">Custom Character</label><span class="required">* </span>
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <v-icon size="small" v-bind="props" class="help-icon">mdi-information-outline</v-icon>
                          </template>
                          <span>Define the AI's personality and conversational style to meet specific use case requirements. </span>
                        </v-tooltip>
                      <v-text-field id="customcharacter-field-uploadvector" v-model="requestVector.customCharacter"
                        variant="outlined" density="compact" hide-details="auto" placeholder="Enter character" class="modern-input"
                        :rules="[checkCustomCharacterValidate()]">
                      </v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mt-4">
                  <v-col cols="12" md="4">
                    <h3 style="font-weight: bold;">Template Document</h3>
                    <span style="color:#646464; font-size: 13px;">
                      View and download template files for each document type by clicking the “Template” button.
                    </span>
                    <br/>
                    <v-btn color="error" class="mt-3" variant="outlined" @click="TemplateVectorDialog()" prepend-icon="mdi-download" style="border-radius: 12px!important; text-transform: none;">
                      Template
                    </v-btn>
                  </v-col>

                  <v-col cols="12" md="8">
                    <h3 style="font-weight: bold;">Upload File</h3>
                    <div class="form-group upload-section" @click="triggerFileUpload">
                      <div class="upload-container">
                        <div class="upload-area" :class="{ 'upload-area--ready': isUploadReady }">
                          <!-- DragDropFile ที่ซ่อนไว้ -->
                          <DragDropFile
                            ref="dragDropRef"
                            :dialog="true"
                            :DragDrop="false"
                            :ShowListFile="false"
                            :accept="accept"
                            :multiple="true"
                            @filesUploaded="processUpload($event)"
                            :allowType="[]"
                            class="modern-upload hidden-upload"
                          />
                          <div class="upload-content">
                          <v-img :src="images.uploadImg" width="30" height="30" class="mb-4 upload-state-icon" />
                          <p class="drag-text">
                              Drag and drop or
                              <span class="choose-file-link">Choose a file to upload.</span>
                          </p>
                          <div class="upload-info">
                              <div class="upload-description">
                                  <span>Maximum file size: 100 MB</span>
                              </div>
                          </div>
                      </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="uploadedFiles.length == 1" class="myrandonthing">
                      <v-row>
                        <v-col cols="8">
                          <v-row>
                            <v-col cols="1" class="pt-1">
                            <v-img :src="getFileIcon(uploadedFiles[0].name)" width="38" height="38" class="mr-2 mt-1" />
                            </v-col>
                            <v-col class="pt-1 filename-txt">
                            <span class="filename-txt">
                              {{uploadedFiles[0].name}}
                            </span><br/>
                            <span class="filesize-txt">{{formatFileSize(uploadedFiles[0].size)}}</span></v-col>
                          </v-row>
                        </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="1" class="pt-1 pr-0 d-flex justify-end">
                      <v-img :src="images.delete1" @click="deleteSingleFile(1)" width="34" height="34" class="ml-2 mt-1" style="cursor: pointer;" /></v-col></v-row>
                    </div>
                    

                    <!-- Multiple files table -->
                    <div v-if="uploadedFiles.length > 1" class="files-table-container mt-4">
                      <v-card variant="outlined" class="files-table-card">
                        <v-data-table
                          v-model="selectedFiles"
                          :headers="fileTableHeaders"
                          :items="uploadedFiles"
                          item-key="name"
                          class="files-data-table"
                          density="compact"
                          hide-default-footer
                          hide-default-header
                          disable-pagination
                          :items-per-page="-1"
                        >
                          <template v-slot:top>
                            <div flat class="files-table-header">
                              <v-checkbox
                                v-model="selectAll"
                                :indeterminate="isIndeterminate"
                                @change="toggleSelectAll"
                                hide-details
                                class="custom-checkbox"
                                label="Select All"></v-checkbox>
                              <v-spacer></v-spacer>
                              <v-btn
                                v-if="selectedFiles.length > 0"
                                color="error"
                                variant="outlined"
                                style="border-radius: 12px!important; text-transform: none;"
                                @click="deleteSelectedFiles"
                              >
                              <v-img :src="images.delete1" class="mr-1" width="22" height="22" />
                              <span class="pt-1">
                                {{ selectedFiles.length === uploadedFiles.length ? $t("deleteAll") : `Delete Selected (${selectedFiles.length})` }}
                              </span> 
                              </v-btn>
                            </div>
                            </template>
                          <template v-slot:item.name="{ item }">
                            <div class="file-name-cell">
                              <v-checkbox
                                v-model="item.checked"
                                hide-details
                                @change="onItemCheckChange(item, $event)"
                                class="custom-checkbox"
                                ></v-checkbox>
                              <v-row>
                                <v-col cols="1" class="pt-2">
                                <v-img :src="getFileIcon(item.name)" width="38" height="38" class="mr-2 mt-1" />
                                </v-col>
                                <v-col class="pt-2">
                                <span class="filename-txt">
                                  {{ item.name }}
                                </span><br/>
                                <span class="filesize-txt">{{formatFileSize(item.size)}}</span></v-col>
                              </v-row>
                            </div>
                          </template>
                          
                          <template v-slot:item.actions="{ item }">
                            <v-img :src="images.delete1" @click="deleteSingleFile(item)" width="30" height="30" class="ml-2" style="cursor: pointer;" />
                          </template>
                        </v-data-table>
                      </v-card>
                    </div>

                  </v-col>
                </v-row>
              </v-form>

              <v-card-actions class="justify-end mt-6">
                <v-btn
                  variant="flat"
                  class="savebtn"
                  @click="nextStep"
                >
                  Next
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-stepper-window-item>

            <!-- STEP 2 -->
            <v-stepper-window-item value="2">
              <v-form class="mt-4" ref="formStep2">
                <v-col cols="12" class="pl-0">
                    <h3 style="font-weight: bold;"> Document Type & Processing</h3>
                  </v-col>
                <v-row>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <div
                      class="lang-detect-wrapper"
                      :class="{ 'lang-detect-on': requestVector.DetectLanguage }"
                      :style="requestVector.DetectLanguage ? 'background: #FFF2F2' : 'background: #EDEDED'"
                    >
                      <div class="lang-detect-header">
                        <label class="lang-detect-label" style="font-weight: bold;">Language Detection</label>
                        <v-tooltip location="right" max-width="280px">
                          <template #activator="{ props }">
                            <v-icon size="small" v-bind="props" class="help-icon ml-1">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>
                            • Enabled: Detects the language automatically and translates it into English.
                            <br />
                            • Disabled: Forces translation from Thai to English only.
                          </span>
                        </v-tooltip>
                      </div>

                      <div class="lang-detect-body">
                        <span>Automatically detect the input language before translation.</span>
                        <v-switch
                          v-model="requestVector.DetectLanguage"
                          inset
                          color="red-lighten-1"
                          hide-details
                          class="mr-5"
                          :class="[
                              'publication-toggle',
                              requestVector.DetectLanguage
                              ? 'publication-toggle--active'
                              : 'publication-toggle--inactive'
                            ]"
                        >
                        </v-switch>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <label class="input-label">Max Character/Chunk</label>
                      <v-tooltip location="top" max-width="300px">
                            <template v-slot:activator="{ props }">
                              <v-icon size="small" v-bind="props" class="help-icon ml-1">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoCustomMaxCharacter") }}</span>
                          </v-tooltip>
                      <v-text-field id="custommaxcharacter-field-uploadvector" :rules="[rules.required]"
                        @keypress="numericKey" v-model="requestVector.MaxLimitedCharacter" variant="outlined" class="modern-input"
                        density="compact" hide-details="auto" placeholder="Max Character/Chunk">
                      </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <label class="input-label">Text Replacement</label>
                      <v-tooltip location="top" max-width="300px">
                            <template v-slot:activator="{ props }">
                              <v-icon size="small" v-bind="props" class="help-icon  ml-1">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoGroupReplaceText") }}</span>
                          </v-tooltip>
                      <v-autocomplete id="textreplacement-autocomplete-uploadvector" :items="DDGroupReplace"
                        item-title="name" item-value="id" multiple chips closable-chips clearable variant="outlined"
                        density="compact" hide-details="auto" placeholder="Text Replacement" class="modern-input"
                        v-model="tempgroupReplaceID">
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item v-bind="props" :id="'textreplacement-uploadvector-option-' + index"
                            :value="item.raw.name">
                            <template v-slot:title>
                              <span>{{ item.raw.name }}</span>
                            </template>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                  </v-col>
                </v-row>

                <!-- Move Personal Information Switch to easy access for edit -->
                <!-- <v-row>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <div class="lang-detect-wrapper">
                      <label style="font-weight: bold;">Personal Information  
                        <v-tooltip location="right" max-width="280px">
                          <template #activator="{ props }">
                            <v-icon size="small" v-bind="props" class="help-icon">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>
                            • Enabled: Only users with permission can view the data.
                            <br />
                            • Disabled: All users can view the data without restriction.
                          </span>
                        </v-tooltip>
                      </label>
                      <div class="lang-detect-body">
                        <span>Control access to personal information.</span>
                        <v-switch id="switch-detect-personal-information" v-model="requestVector.PersonalInfo"
                            color="#C32E0E" inset hide-details
                            :class="[
                              'publication-toggle',
                              requestVector.PersonalInfo
                              ? 'publication-toggle--active'
                              : 'publication-toggle--inactive'
                            ]"
                            @change="UpdatePersonalInformation(searchVectorDBName2)">
                          </v-switch>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <div
                      class="lang-detect-wrapper"
                      :class="{ 'lang-detect-on': requestVector.DetectLanguage }"
                    >
                      <div class="lang-detect-header">
                        <label class="lang-detect-label" style="font-weight: bold;">Language Detection</label>
                        <v-tooltip location="right" max-width="280px">
                          <template #activator="{ props }">
                            <v-icon size="small" v-bind="props" class="help-icon ml-1">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>
                            • Enabled: Detects the language automatically and translates it into English.
                            <br />
                            • Disabled: Forces translation from Thai to English only.
                          </span>
                        </v-tooltip>
                      </div>

                      <div class="lang-detect-body">
                        <span>Automatically detect the input language before translation.</span>
                        <v-switch
                          v-model="requestVector.DetectLanguage"
                          inset
                          color="red-lighten-1"
                          hide-details
                          class="mr-5"
                          :class="[
                              'publication-toggle',
                              requestVector.DetectLanguage
                              ? 'publication-toggle--active'
                              : 'publication-toggle--inactive'
                            ]"
                        >
                        </v-switch>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                      <label class="input-label">Text Replacement</label>
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon size="small" v-bind="props" class="help-icon  ml-1">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoGroupReplaceText") }}</span>
                            </v-tooltip>
                        <v-autocomplete id="textreplacement-autocomplete-uploadvector" :items="DDGroupReplace"
                          item-title="name" item-value="id" multiple chips closable-chips clearable variant="outlined"
                          density="compact" hide-details="auto" placeholder="Text Replacement" class="modern-input"
                          v-model="tempgroupReplaceID">
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" :id="'textreplacement-uploadvector-option-' + index"
                              :value="item.raw.name">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                  </v-col> 
                </v-row> -->
              </v-form>
              <v-card-actions class="justify-space-between mt-6">
                <v-btn
                  outlined
                  class="backbtn"
                  @click="prevStep"
                >
                  <v-icon left>mdi-arrow-left</v-icon>
                  Back
                </v-btn>

                <v-btn
                  class="savebtn"
                  @click="saveDoc()"
                >
                  <v-img :src="images.savebtn" class="mr-2" width="16" height="16"></v-img>
                  Save
                </v-btn>
              </v-card-actions>
            </v-stepper-window-item>
          </v-stepper-window>
        </v-stepper>
      </v-card>
    </v-container>
    
    <v-overlay :model-value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card class="loading-card">
          <v-card-text class="text-center pa-6">
            <v-progress-circular indeterminate color="primary" size="64" class="mb-4">
            </v-progress-circular>
            <div class="text-h6">Loading Please Wait...</div>
            <v-progress-linear indeterminate color="primary" class="mt-4">
            </v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>

    <v-dialog v-model="TemplateVector" max-width="800px" persistent>
      <v-card class="template-dialog">
        <v-card-title class="template-header">
          <div class="header-content">
            <div class="header-text">
              <h2 class="dialog-title">Template Vector</h2>
              <p class="dialog-subtitle">
                A collection of ready-to-use template files for different document types.
              </p>
            </div>
          </div>
          <v-btn icon variant="text" size="small" @click="TemplateVector = false" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="template-content">
          <div class="template-description">
            <v-alert class="mb-4 custom-alert" density="compact">
              <div class="alert-content">
                <strong>How to use templates:</strong>
                <ul class="template-instructions">
                  <li>
                    Select the appropriate template for your document type
                  </li>
                  <li>Download the template file format you prefer</li>
                  <li>Fill in your data following the template structure</li>
                  <li>
                    Upload the completed file using the upload section above
                  </li>
                </ul>
              </div>
            </v-alert>
          </div>

          <!-- PROCESSING TYPE SECTION -->
          <v-card class="pa-5 rounded-lg processcard">
            <h3 style="font-weight: bold;">
              <v-img :src="images.processtype" class="mr-2" width="24" height="24"
                style="display: inline-block; vertical-align: middle;" />
              Processing Type
            </h3>

                <v-radio-group v-model="selectedType" row>
                <v-row class="mt-5 mb-5">
                  <v-col
                    v-for="type in dataTemplate"
                    :key="type.value"
                    cols="12"
                    sm="6"
                    md="4"
                    class="d-flex"
                  >
                    <div
                      class="processing-option d-flex"
                      :class="{ active: selectedType === type.value }"
                    >
                      <v-radio
                        :label="type.label"
                        :value="type.value"
                        color="red darken-2"
                        hide-details
                      ></v-radio>
                      <v-tooltip v-if="type.label == 'Custom Split'" location="top" max-width="300px" >
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" size="small" color="#a6a6a6" class="info-tooltip">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div class="custom-tooltip">
                        <strong>CustomSplit Template:</strong><br />
                        Use "||!" as separator<br />
                        Example: SplitChunkContent
                      </div>
                    </v-tooltip>
                    </div>
                  </v-col>
                </v-row>
              </v-radio-group>
            <h3 style="font-weight: bold;">
              <v-img :src="images.fileformat" class="mr-2" width="24" height="24"
                style="display: inline-block; vertical-align: middle;" />
              File Format
            </h3>

            <v-row class="mt-5">
              <v-col v-for="file in visibleFormats " :key="file.value" cols="12" sm="6" md="2" lg="2">
                <v-card class="text-center hoverable file-card" outlined
                  @click="linkDownload(selectedType, file.value)">
                  <div class="imgsection" :class="{
                    'bg-csv': file.value.includes('CSV'),
                    'bg-excel': file.value.includes('Excel'),
                    'bg-multicol': file.value.includes('ExcelMultiColumn'),
                    'bg-pdf': file.value.includes('PDF'),
                    'bg-word': file.value.includes('Word'),
                    'bg-ppt': file.value.includes('PowerPoint'),
                    'bg-txt': file.value.includes('Text'),
                  }"><v-img :src="file.icon" width="36" height="36" class="mb-2 mt-1 cardImg" /></div>
                  <div class="text-subtitle-2">{{ file.label }}</div>
                  <!-- :class="fileTypeClass(file.value)"    -->
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="template-actions">
          <v-spacer></v-spacer>
          <v-btn variant="elevated" color="red" @click="TemplateVector = false" class="create-btn mr-0">
            <v-icon start>mdi-close</v-icon>
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteType === 'all'">
            Are you sure you want to delete all Files? This action cannot be undone.
          </span>
          <span v-else-if="deleteType === 'individual'">
            Are you sure you want to delete these Files? This action cannot be undone.
          </span>
          <span v-else>
            Are you sure you want to delete this item? This action cannot be undone.
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <img :src="images.trashBin" alt="Delete" class="white-svg" />
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Custom Reprocess Dialog -->
    <v-dialog v-model="dialog_reprocess" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="reprocess-dialog-title">Reprocess Document</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelReprocess"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span>
            Are you sure you want to reprocess this document?
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelReprocess"
          >
            Cancel
          </v-btn>
          <v-btn
            class="reprocess-confirm-btn"
            @click="confirmReprocess"
          >
            <v-icon left size="18">mdi-file</v-icon>
            Reprocess
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>
<script>
import DragDropFile from "@/components/DragDropFile.vue";
import generalImg from "@/assets/images/Group 11.svg";
import maxCharacterImg from "@/assets/images/Group 12.svg";
import customSplitImg from "@/assets/images/Group 13.svg";
import articleImg from "@/assets/images/Group 13.svg";
import headerAllChunkImg from "@/assets/images/Group 11.svg";
import headerFirstChunkImg from "@/assets/images/Group 12.svg";
import wordImageImg from "@/assets/images/Group 12.svg";
import pdfImageImg from "@/assets/images/Group 12.svg";
import csvImg from "@/assets/images/csv.png";
import excelImg from "@/assets/images/excel.png";
import fileexcelImg from "@/assets/images/multi-excel.png";
import pdfImg from "@/assets/images/pdf2.png";
import wordImg from "@/assets/images/microsoft-word.png";
import pptImg from "@/assets/images/powerpoint.png";
import txtImg from "@/assets/images/txt.png";
import dividerImg from "@/assets/images/divider.png";
import dividercompleteImg from "@/assets/images/completeline.png";
import uploadImg from "@/assets/images/upload.png";
import reprocess from "@/assets/images/file-settings-line.png";
import replaceall from "@/assets/images/replaceallwhite.png";
import deleteImg1 from "@/assets/Icons/Delete.png";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import savebtn from '@/assets/images/savecard.png';
import processtype from "@/assets/images/flat-color-icons_process.png";
import fileformat from "@/assets/images/memory_format-text.png";
import TrashBinImg from "@/assets/images/trash-solid.svg";

import { useDisplay } from "vuetify";
import LogTrace from "@/api/function.js";

export default {
  name: "UploadVector",
  mixins: [LogTrace],
  components: { DragDropFile },
  props: ["id"],
  inject : [
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  setup() {
    const { smAndUp } = useDisplay();

    return {
      smAndUp,
    };
  },
  data: () => ({
    uploadDialog: false,
    checkbox1: false,
    actionEdit: false,
    TemplateVector: false,
    dialog: false,
    loadingTable: false,
    TitleName: null,
    step: "1",
    errors: {
      documentNameError: null,
      doctypeError: null,
      vectortypeError: null,
      modelTypeError: null,
    },
    Edit: {
      id: null,
      textORG: null,
    },
    flagNew: true,
    Add: {
      id: null,
      textORG: null,
    },
    loading: true,
    loadingDownload: true,
    today: null,
    searchVectorDBName: null,
    searchVectorDBName2: null,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
      deleteAll: false,
      groupReplaceID: null,
      customCharacter: null,
      DetectLanguage: true,
      MaxLimitedCharacter: null,
      PersonalInfo: false,
    },
    searchtext_org: null,
    modelType: null,
    doctype: null,
    vectortype: null,
    tempgroupReplaceID: null,
    options: {},
    options2: {},
    DDModel: [],
    files: [],
    dataTable: [],
    dataTable2: [],
    uploadedFiles: [],
    selectedFiles: [],
    fileTableHeaders: [
      { title: 'File Name', key: 'name', sortable: false },
      { title: 'Actions', key: 'actions', sortable: false, width: '80px', align: 'center' }
    ],
    selectAll: false,
    DDGroupReplace: [],
    filterdatavectortype: [],
    filterDDType: [],
    DDType: [
      {
        id: 'General',
        name: 'General',
        value: 1,
        image: generalImg,
      },
      {
        id: 'MaxCharacter',
        name: 'MaxCharacter',
        value: 2,
        image: maxCharacterImg,
      },
      {
        id: 'CustomSplit',
        name: 'CustomSplit',
        value: 3,
        image: customSplitImg,
      },
      {
        id: 'Article',
        name: 'Article',
        value: 4,
        image: articleImg,
      },
      {
        id: 'HeaderAllChunk',
        name: 'HeaderAllChunk',
        value: 5,
        image: headerAllChunkImg,
      },
      {
        id: 'HeaderFirstChunk',
        name: 'HeaderFirstChunk',
        value: 6,
        image: headerFirstChunkImg,
      },
      {
        id: 'WordImage',
        name: 'WordImage',
        value: 7,
        image: wordImageImg,
      },
      {
        id: 'PDFImage',
        name: 'PDFImage',
        value: 8,
        image: pdfImageImg,
      },
    ],
    datadoctype: [
      { id: 'Csv', name: 'CSV', value: 1 },
      { id: 'Excel', name: 'Excel', value: 2 },
      { id: 'Pdf', name: 'PDF', value: 3 },
      { id: 'Word', name: 'Word', value: 4 },
      { id: 'Text', name: 'Text', value: 5 },
      { id: 'Powerpoint', name: 'PowerPoint', value: 6 },
    ],
    datavectortype: [
      { id: 'General', name: 'General', value: 1 },
      { id: 'Article', name: 'Article', value: 2 },
      { id: 'PriceList', name: 'PriceList', value: 3 },
    ],
    dataTemplate: [
      {
        modeType: "General",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
        label: "General",
        value: "General",
      },
      {
        modeType: "MaxCharacter",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
        label: "Max Character",
        value: "MaxCharacter"
      },
      {
        modeType: "CustomSplit",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
        label: "Custom Split",
        value: "CustomSplit"
      },
      {
        modeType: "Article",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
        label: "Article",
        value: "Article"
      },
      {
        modeType: "HeaderAllChunk",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
        label: "Header (All Chunk)",
        value: "HeaderAllChunk"
      },
      {
        modeType: "HeaderFirstChunk",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
        label: "Header (First Chunk Only)",
        value: "HeaderFirstChunk"
      },
    ],
    modeType: [
      {
        name: "Add",
        value: false,
      },
      {
        name: "Replace",
        value: true,
      },
    ],
    isSearch: false,
    isSearch2: false,
    isFirst: true,
    isFirst2: true,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,

    searchTotalTable2: 0,
    itemsPerPage2: 10,
    showTable: true,
    dataUpdate: -1,
    dataAll: 0,
    exceptionFlag: false,
    vectornameDuplicate: false,
    VectorDBNameDuplicate: "",
    DisabledBtn: false,
    accept: "",
    panel: [0],
    rules: {
      required: (value) => !!value || "Required.",
      // required2 : this.vectornameDuplicate || 'dup'
    },
    images: {
      edit: editImg,
      delete: deleteImg,
      delete1: deleteImg1,
      processtype: processtype,
      fileformat: fileformat,
      csvImg: csvImg,
      excelImg: excelImg,
      fileexcelImg: fileexcelImg,
      pdfImg: pdfImg,
      wordImg: wordImg,
      pptImg: pptImg,
      txtImg: txtImg,
      dividerImg: dividerImg,
      dividercompleteImg: dividercompleteImg,
      uploadImg: uploadImg,
      savebtn: savebtn,
      reprocess: reprocess,
      replaceall: replaceall,
      trashBin: TrashBinImg,
    },
    sortBy: [],
    sortDesc: [],
    ShowAllText: false,
    CheckboxShowAllText: false,
    tempTitle: "",
    tempText: "",
    selectedType: "General",
    dialog_delete: false,
    deleteItem: null,
    deleteType: null,
    dialog_reprocess: false,
  }),
  created() {
    // Read query param
    this.TitleName = this.$route?.query?.DocEdit === '1' ? this.$t("_AddMoreDoc") : this.$t("_ReplaceAllDoc");
    
  },
  computed: {
    enhancedHeadersTemplate() {
      return [
        {
          title: "Processing Type",
          key: "modeType",
          align: "center",
          width: "160px",
          sortable: false,
        },
        {
          title: "CSV",
          key: "csv",
          align: "center",
          width: "100px",
          sortable: false,
        },
        {
          title: "Excel",
          key: "excel",
          align: "center",
          width: "140px",
          sortable: false,
        },
        {
          title: "PDF",
          key: "pdf",
          align: "center",
          width: "100px",
          sortable: false,
        },
        {
          title: "Word",
          key: "word",
          align: "center",
          width: "100px",
          sortable: false,
        },
        {
          title: "PowerPoint",
          key: "powerpoint",
          align: "center",
          width: "120px",
          sortable: false,
        },
        {
          title: "Text",
          key: "text",
          align: "center",
          width: "100px",
          sortable: false,
        },
      ];
    },
    fileFormats() {
      return [
        { label: "CSV", value: "CSV", icon: this.images.csvImg, color: "green" },
        { label: "Excel", value: "Excel", icon: this.images.excelImg, color: "green-darken-2" },
        { label: "Multi-Col", value: "ExcelMultiColumn", icon: this.images.fileexcelImg, color: "teal" },
        { label: "PDF", value: "PDF", icon: this.images.pdfImg, color: "red" },
        { label: "Word", value: "Word", icon: this.images.wordImg, color: "blue" },
        { label: "PPT", value: "PowerPoint", icon: this.images.pptImg, color: "orange" },
        { label: "TXT", value: "Text", icon: this.images.txtImg, color: "grey-darken-1" },
      ];
    },
    visibleFormats() {
    switch (this.selectedType) {
      case "MaxCharacter":
        return this.fileFormats;
      case "CustomSplit":
        return this.fileFormats.filter(f =>
          ["PDF","Word","PPT","PowerPoint","Text"].includes(f.value)
        );
      case "Article":
        return this.fileFormats.filter(f =>
          ["PDF","Word","PPT","PowerPoint","Text"].includes(f.value)
        );
      case "HeaderAllChunk":
        return this.fileFormats.filter(f =>
          ["CSV","ExcelMultiColumn"].includes(f.value)
        );
      case "HeaderFirstChunk":
        return this.fileFormats.filter(f =>
          ["CSV","ExcelMultiColumn"].includes(f.value)
        );
      default:
        return this.fileFormats;
    }
    },
    headers2() {
      return [
        {
          title: this.$t("no"),
          key: "number",
          align: "center",
          sortable: false,
          width: this.smAndUp ? "60px" : "30px",
        },
        {
          title: "Text_org",
          key: "textORG",
          align: "left",
          sortable: true,
          width: this.smAndUp ? "40%" : "300px",
        },
        {
          title: "Text_en",
          key: "textEN",
          align: "left",
          sortable: true,
          width: this.smAndUp ? "40%" : "300px",
        },
        {
          title: this.$t("manage"),
          key: "actions",
          align: "center",
          sortable: false,
          width: this.smAndUp ? "15%" : "auto",
        },
      ];
    },
    headersTemplate() {
      return [
        { text: "Type", align: "center", width: "25%" },
        { text: "CSV", align: "center" },
        { text: "Excel", align: "center" },
        { text: "PDF", align: "center" },
        { text: "Word", align: "center" },
        { text: "PowerPoint", align: "center" },
        { text: "Text", align: "center" },
      ];
    },
    isUploadReady() {
      return [
        this.doctype?.value,
        this.vectortype?.value,
        this.requestVector?.modelType,
      ].every((value) => value !== null && value !== undefined && value !== "");
    },
    // Computed properties for select all functionality
    isIndeterminate() {
      return this.selectedFiles.length > 0 && this.selectedFiles.length < this.uploadedFiles.length;
    },
  },
  watch: {
    options2: {
      handler() {
        if (this.refreshTimeout) {
          clearTimeout(this.refreshTimeout);
        }
        this.refreshTimeout = setTimeout(() => {
          this.ReFresh();
        }, 300);
      },
      deep: true,
    },
    selectedFiles: {
      handler() {
        // Update selectAll checkbox state based on selected files
        if (this.selectedFiles.length === 0) {
          this.selectAll = false;
        } else if (this.selectedFiles.length === this.uploadedFiles.length) {
          this.selectAll = true;
        }
        // Note: indeterminate state is handled by the computed property isIndeterminate
      },
      deep: true,
    },
    requestVector: {
      handler(newVal) {
        if (newVal.modelType != 3) {
          this.requestVector.customCharacter = null;
        }
      },
      deep: true,
    },
    searchVectorDBName2: {
      handler() {
        // Clear document name error when user starts typing
        if (this.errors.documentNameError) {
          this.errors.documentNameError = null;
        }
      }
    },
    doctype: {
      handler(val) {
        let self = this;
        if (self.errors.doctypeError) {
          self.errors.doctypeError = null;
        }
        self.vectortype = null;
        self.filterDDType = [];
        self.filterdatavectortype = [];
        if (val.value == 1 || val.value == 2) {
          self.filterdatavectortype = self.datavectortype.filter(
            (e) => e.value != 2
          );
        } else {
          self.filterdatavectortype = self.datavectortype.filter(
            (e) => e.value != 3
          );
        }

        this.filterDDType = [];
        this.requestVector.customCharacter = null;
        self.setTypeFile(val);
      },
    },
    vectortype: {
      handler(val) {
        let self = this;
        if (val) {
          this.errors.vectortypeError = null;
        }
        self.filterDDType = [];
        self.requestVector.customCharacter = null;
        if (val && val.value == 2) {
          self.filterDDType = self.DDType.filter((e) => e.value == 4);
        } else if (val && val.value == 3 && (self.doctype && self.doctype.value == 1 || self.doctype && self.doctype.value == 2)) {
          self.filterDDType = self.DDType.filter(
            (e) => e.value == 5 || e.value == 6
          );
        } else {
          if (self.doctype.value == 4) {
            self.filterDDType = self.DDType.filter(
              (e) =>
                e.value == 1 || e.value == 2 || e.value == 3 || e.value == 7
            );
          } else if (self.doctype.value == 3) {
            self.filterDDType = self.DDType.filter(
              (e) =>
                e.value == 1 || e.value == 2 || e.value == 3 || e.value == 8
            );
          } else {
            self.filterDDType = self.DDType.filter(
              (e) => e.value == 1 || e.value == 2 || e.value == 3
            );
          }
        }
        self.requestVector.modelType = null;
      },
    },
    'requestVector.modelType'(val) {
        if (val) {
          this.errors.modelTypeError = null;
        }
      },
    CheckboxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    },
  },
  methods: {
    btnDisableDelete(item) {
      if (this.RoleId == 2 && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    nextStep() {
      this.errors.documentNameError = (!this.searchVectorDBName2 || this.searchVectorDBName2.trim() === '') ? 'Required.' : null;
      this.errors.doctypeError = !this.doctype ? 'Required.' : null;
      this.errors.vectortypeError = !this.vectortype ? 'Required.' : null;
      this.errors.modelTypeError = !this.requestVector.modelType ? 'Required.' : null;
      if (this.errors.documentNameError || this.errors.doctypeError || this.errors.vectortypeError || this.errors.modelTypeError) {
        return;
      }
      this.step = "2";
    },
    prevStep() {
      this.step = "1";
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // Select all files
        for(let i=0; i<this.uploadedFiles.length; i++){
          this.uploadedFiles[i].checked = true;
        }
        this.selectedFiles = [...this.uploadedFiles];
      } else {
        // Deselect all files
        this.selectedFiles = [];
        for(let i=0; i<this.uploadedFiles.length; i++){
          this.uploadedFiles[i].checked = false;
        }
      }
    },
    onItemCheckChange(item, checked) {
      if (checked) {
        if (!this.selectedFiles.some(f => f.id === item.id)) {
          this.selectedFiles.push(item);
        }
      } else {
        this.selectedFiles = this.selectedFiles.filter(f => f.id !== item.id);
      }
    },
    getModeTypeColor(modeType) {
      const colorMap = {
        General: "blue",
        MaxCharacter: "green",
        CustomSplit: "orange",
        Article: "purple",
        HeaderAllChunk: "teal",
        HeaderFirstChunk: "cyan",
      };
      return colorMap[modeType] || "grey";
    },
    handleOptionsUpdate(options) {
      this.options2 = options;
    },
    formatText(text) {
      // แปลงช่องว่างเป็น &nbsp; เพื่อให้รักษาช่องว่างได้
      if(text){
        return text.replace(/ /g, '&nbsp;');
      }
      return "-";      
    },

    numericKey: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleKeypress(evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      // กำหนด Regular Expression สำหรับตรวจสอบตัวอักษรไทย, อังกฤษ, ตัวเลข, เครื่องหมายขีด และเครื่องหมายขีดล่าง
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F\-_]+$/;

      if (!validCharactersRegex.test(String.fromCharCode(charCode))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handlePaste(evt) {
      // รับข้อความจาก clipboard
      const clipboardData = evt.clipboardData || window.clipboardData;
      let pastedText = clipboardData.getData("text");

      // กรองเฉพาะตัวอักษรที่อนุญาตเท่านั้น (รวมเครื่องหมายขีด และเครื่องหมายขีดล่าง)
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F\-_]+$/;
      let filteredText = "";

      // วนลูปตรวจสอบแต่ละตัวอักษรในข้อความที่วาง
      for (let i = 0; i < pastedText.length; i++) {
        const char = pastedText.charAt(i);
        if (validCharactersRegex.test(char)) {
          filteredText += char;
        }
      }

      // ป้องกันการดำเนินการปกติของการวาง
      evt.preventDefault();

      // นำข้อความที่ผ่านการกรองแล้วมาต่อกับข้อความเดิม
      const cursorPos = evt.target.selectionStart;
      const textBeforeCursor = this.searchVectorDBName2
        ? this.searchVectorDBName2.substring(0, cursorPos)
        : "";
      const textAfterCursor = this.searchVectorDBName2
        ? this.searchVectorDBName2.substring(cursorPos)
        : "";

      // อัปเดตค่าใน v-model
      this.searchVectorDBName2 =
        textBeforeCursor + filteredText + textAfterCursor;

      // เลื่อน cursor ไปยังตำแหน่งหลังข้อความที่วาง
      this.$nextTick(() => {
        evt.target.selectionStart = evt.target.selectionEnd =
          cursorPos + filteredText.length;
      });
    },
    checkValidate() {
      if (this.searchVectorDBName2 == "" || this.searchVectorDBName2 == null) {
        return "Required.";
      } else if (this.VectorDBNameDuplicate == this.searchVectorDBName2) {
        return "Duplicate";
      }
      return true;
    },
    checkCustomCharacterValidate() {
      if (
        this.requestVector.modelType == 3 &&
        (this.requestVector.customCharacter == "" ||
          this.requestVector.customCharacter == null)
      ) {
        return "Required.";
      } else {
        this.customCharacter = null;
      }
      return true;
    },

    GetByVector() {
      let self = this;
      self.loadingTable = true;
      let { page, itemsPerPage, sortBy } = self.options2;

      // Vue 3 + Vuetify 3: ปรับการจัดการ sorting
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : null,
        name:
          self.$route.query.name != null
            ? self.$route.query.name
            : self.searchVectorDBName2,
        text_org: self.searchtext_org,
        sortDesc: sortOrder,
        sortBy: sortField,
      };

      self.$call.ReFreshVector(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.dataUpdate = dataResponse.data.dataUpdate;
            self.dataAll = dataResponse.data.dataAll;
            self.exceptionFlag = dataResponse.data.exceptionFlag;
            self.searchTotalTable2 = dataResponse.data.table.total;
            self.dataTable2 = dataResponse.data.table.data;
            self.totalTable = dataResponse.data.table.total;
            self.tempgroupReplaceID = dataResponse.data.groupReplaceID;
            if (this.$route.query.name) {
              self.requestVector.customCharacter =
                dataResponse.data.customCharacter;
              self.requestVector.DetectLanguage = dataResponse.data.detectLanguage;
              self.requestVector.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
              self.requestVector.PersonalInfo = dataResponse.data.personalInformation;
            }
            self.AutoRefresh();
          } else {
            self.dataTable2 = [];
            self.searchTotalTable2 = 0;
            self.totalTable = 0;
            self.actionEdit = false;
          }
          self.loadingTable = false;
          self.isSearch2 = false;
          self.isFirst2 = false;
          self.showTable = true;
          self.dataTable2.forEach((element) => {
            element.show = self.ShowAllText;
          });
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch2 = false;
          console.error(errorResource);
        }
      );
    },
    validateTypeFile(type) {
      let self = this;
      let doctype = 0;
      switch (type) {
        case "text/csv":
          doctype = 1;
          break;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          doctype = 2;
          break;
        case "application/pdf":
          doctype = 3;
          break;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          doctype = 4;
          break;
        case "text/plain":
          doctype = 5;
          break;
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
          doctype = 6;
          break;
      }
      if (self.doctype == doctype) {
        return true;
      }
      return false;
    },
    saveDoc() {
      let self = this;
      const hasFiles = (self.uploadedFiles && self.uploadedFiles.length > 0) || self.requestVector.entity;
      const vectorDbName = self.$route.query.name || self.searchVectorDBName2;
      if (!self.requestVector.modelType || !vectorDbName || !hasFiles) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      if (self.requestVector.modelType == 3 && !self.requestVector.customCharacter) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      if (this.requestVector.MaxLimitedCharacter == null || this.requestVector.MaxLimitedCharacter == "" || this.requestVector.MaxLimitedCharacter == undefined) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please fill in the Custom Max Character',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      const formDataDoc = new FormData();
      formDataDoc.append("vectordbName", vectorDbName);
      formDataDoc.append("modelType", self.requestVector.modelType);

      const deleteAllValue = self.$route?.query?.DocEdit === '2' ? true : (self.requestVector.deleteAll || false);
      formDataDoc.append("deleteAll", deleteAllValue);

      formDataDoc.append("DetectLanguage", self.requestVector.DetectLanguage || false);
      formDataDoc.append("MaxLimitedCharacter", self.requestVector.MaxLimitedCharacter);
      
      if (self.requestVector.customCharacter) {
        formDataDoc.append("customCharacter", self.requestVector.customCharacter);
      }
      if (self.tempgroupReplaceID) {
        formDataDoc.append("groupReplaceID", JSON.stringify(self.tempgroupReplaceID));
      }
      if (self.requestVector.PersonalInformation) {
        formDataDoc.append("PersonalInformation", self.requestVector.PersonalInformation);
      }

      const filesToUpload = self.selectedFiles && self.selectedFiles.length > 0 
        ? self.selectedFiles 
        : self.uploadedFiles;

      if (filesToUpload && filesToUpload.length > 0) {
        filesToUpload.forEach(fileItem => {
          const file = fileItem.originalFile || fileItem; // Handle both wrapped and direct file objects
          formDataDoc.append("entity", file);
        });
      }
      self.dialog = true;
      try {
        const eventCreate = self.$route.query.name == null ? true : false;
        self.$call.UploadCSV2VectorNew(
          formDataDoc,
          eventCreate,
          (dataResponse) => {
            if (dataResponse.status == 0 && dataResponse.data !== false) {
              let msgSuccess = "✔ " +
                dataResponse.message;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                backdrop: true,
                customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
              });
              self.requestVector.entity = null;
              self.actionEdit = true;
              self.flagNew = false;
              self.uploadedFiles = [];
              self.selectedFiles = [];
              self.selectAll = false;
              self.clearDragDropRef();
              localStorage.setItem("ExceptionFlagStop", "false");
              self.dialog = false;
              self.$router.push({
                name: "UploadVector",
                query: { name: vectorDbName },
              });
              return;
            } else if (dataResponse.status == 0 && dataResponse.data == false) {
              self.$swal.fire({
                icon: "warning",
                title: this.$t("warningWaitProcess"),
                showConfirmButton: false,
                timer: 4000,
              });
            } else {
              let msgSuccess = "✔ " +
                dataResponse.message;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                backdrop: true,
                customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
              });
              localStorage.setItem("ExceptionFlagStop", "false");
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    validateUploadPrerequisites(showAlert = false) {
      this.errors.doctypeError = !this.doctype ? 'Required.' : null;
      this.errors.vectortypeError = !this.vectortype ? 'Required.' : null;
      this.errors.modelTypeError = !this.requestVector?.modelType ? 'Required.' : null;

      const hasError = Boolean(
        this.errors.doctypeError ||
        this.errors.vectortypeError ||
        this.errors.modelTypeError
      );

      if (hasError && showAlert) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Please select all required dropdowns first.',
          showConfirmButton: false,
          timer: 1500,
        });
      }

      return !hasError;
    },
    triggerFileUpload() {
        if (!this.validateUploadPrerequisites(true)) {
            this.clearDragDropRef();
            return;
        }

        if (this.$refs.dragDropRef && this.$refs.dragDropRef.$el) {
            const fileInput = this.$refs.dragDropRef.$el.querySelector('input[type="file"]');
            if (fileInput) {
                fileInput.click();
            }
        }
    },
    processUpload(e) {
      this.files = e;
      if (!this.validateUploadPrerequisites()) {
        this.requestVector.entity = null;
        this.files = [];
        this.clearDragDropRef();
        return;
      }

      if (this.files.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        this.selectedFiles = [];
        this.selectAll = false;
        return;
      }
      // Validate file sizes (100 MB = 104,857,600 bytes)
      const maxFileSize = 100 * 1024 * 1024; // 100 MB in bytes
      const oversizedFiles = this.files.filter(file => file.size > maxFileSize);
      
      if (oversizedFiles.length > 0) {
        const fileDetails = oversizedFiles.map(file =>
          `${file.name} (${this.formatFileSize(file.size)})`
        ).join('\n');
        
        this.$swal.fire({
          icon: 'error',
          title: 'File Size Exceeded',
          html: `The following files exceed the maximum size limit of 100 MB:<br><br><div style="text-align: left; font-family: monospace;">${fileDetails.replace(/\n/g, '<br>')}</div>`,
          showConfirmButton: true,
        });
        this.clearDragDropRef();
        return;
      }
      // Add new files to existing uploadedFiles array (avoid duplicates)
      const newFiles = this.files.filter(newFile => 
        !this.uploadedFiles.some(existingFile => existingFile.name === newFile.name)
      );
      this.uploadedFiles = [...this.uploadedFiles, ...newFiles,];
      this.selectedFiles = []; // Clear selection when new files are added
      this.selectAll = false;

      if (this.uploadedFiles.length > 0) {
        // Read first file for validation (you may want to validate all files)
        const reader = new FileReader();
        reader.readAsText(this.uploadedFiles[0]);
        reader.onload = () => {
          let text = reader.result;
          this.ValidateCSVVector(text, this.uploadedFiles);
          //this.ConfirmProcess();
        };
      }
      
    },

    ValidateCSVVector(csv, files) {
      const formDataDoc = new FormData();
      
      // Add all files with the same field name 'entity'
      files.forEach(file => {
        formDataDoc.append("entity", file.originalFile || file); // always a real File
      });
      
      // Add other form parameters as form fields (not query params)
      formDataDoc.append("vectordbName", this.searchVectorDBName2);
      formDataDoc.append("modelType", this.requestVector.modelType);
      const deleteAllValue = this.$route?.query?.DocEdit === '2' ? true : (this.requestVector.deleteAll || false);
      formDataDoc.append("deleteAll", deleteAllValue);
      formDataDoc.append("DetectLanguage", this.requestVector.DetectLanguage || false);
      formDataDoc.append("MaxLimitedCharacter", this.requestVector.MaxLimitedCharacter || 20000);
      
      if (this.requestVector.customCharacter) {
        formDataDoc.append("customCharacter", this.requestVector.customCharacter);
      }
      if (this.tempgroupReplaceID) {
        formDataDoc.append("groupReplaceID", JSON.stringify(this.tempgroupReplaceID));
      }
      if (this.requestVector.PersonalInformation) {
        formDataDoc.append("PersonalInformation", this.requestVector.PersonalInformation);
      }
      
      this.uploadedFiles = files.map((file, i) => {
        const originalFile = file.originalFile || file;
        return {
          id: i + 1,
          checked: false,
          name: originalFile.name,
          size: originalFile.size,
          type: originalFile.type,
          originalFile: originalFile,  // keeps File ref for FormData
        };
      });
      for(let i=0; i<this.uploadedFiles.length; i++){
        this.uploadedFiles[i].id = i + 1;
        this.uploadedFiles[i].checked = false;
      }
      this.requestVector.entity = formDataDoc;
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex(
        (file) => file.name === fileName
      );
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.$emit("filesUploaded", this.uploadedFiles);
    },
    DeleteByName(name) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionDocument"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteVectorDBNameByName(
                name,
                async (dataResponse) => {
                  if (dataResponse.status == 0) {
                    let msgSuccess = "✔ " +
                      dataResponse.message;
                    self.$swal.fire({
                      title: msgSuccess,
                      showConfirmButton: false,
                      timer: 1500,
                      position: 'top',
                      backdrop: true,
                      customClass: {
                              popup: 'success-banner',
                              title: 'success-banner-title'
                            },
                    });
                    self.dataUpdate = 0;
                    self.dataAll = 0;
                    self.actionEdit = false;
                    self.flagNew = true;
                    self.Clear();
                    self.GetByVector();

                    await this.$router.push('/VectorManagement');
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Clear() {
      let self = this;
      self.showTable = false;

      self.requestVector.entity = null;
      self.requestVector.modelId = null;
      self.requestVector.vectordbName = null;

      self.searchVectorDBName = null;
      self.searchVectorDBName2 = null;
      self.dataTable2 = [];
      self.searchTotalTable2 = 0;
      self.totalTable = 0;

      this.$emit("back", true);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      this.today = dd + "/" + mm + "/" + yyyy;
    },

    linkDownload(modelType, filename) {
      let self = this;
      let req = {
        modelType: modelType,
        filename: filename,
      };
      self.$call.DownloadTemplateVector_Stream(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            let fileNameshow = `Template_${modelType}_${filename}${self.findTypeName(
              filename
            )}`;
            fileLink.setAttribute("download", fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.TemplateVector = false;
        },
        (errorResource) => {
          self.TemplateVector = false;
          console.error(errorResource);
        }
      );
    },
    findTypeName(filename) {
      let type = "";
      switch (filename) {
        case "CSV":
          type = ".csv";
          break;
        case "Excel":
          type = ".xlsx";
          break;
        case "ExcelMultiColumn":
          type = ".xlsx";
          break;
        case "PDF":
          type = ".pdf";
          break;
        case "Word":
          type = ".docx";
          break;
        case "Text":
          type = ".txt";
          break;
        case "PowerPoint":
          type = ".pptx";
          break;
      }
      return type;
    },
    setTypeFile(val) {
      let self = this;

      switch (val.value) {
        case 1:
          self.accept = ".csv";
          break;
        case 2:
          self.accept =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          break;
        case 3:
          self.accept = "application/pdf";
          break;
        case 4:
          self.accept =
            ".doc, .docx, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          break;
        case 5:
          self.accept = "text/plain";
          break;
        case 6:
          self.accept =
            ".ppt, .pptx, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation";
          break;
        default:
          self.accept = "";
          break;
      }
    },
    download() {
      const data = [];
      data.push("\ufefftext_org\r\n");
      data.push("ปากกา 10 บาท\r\n");
      data.push("ดินสอ 20 บาท\r\n");
      data.push("ถาม:กินข้าว ตอบ:กินหมูปิ้ง");

      const a = document.createElement("a");
      let blob = new Blob(data, { type: "data:text/csv;charset=UTF-8" });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = "upload_vector.csv";
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
    cancelReprocess() {
      this.dialog_reprocess = false;
    },
    ReProcess() {
      this.dialog_reprocess = true;
    },
    confirmReprocess(){
      let self = this;
      if (
        this.requestVector.MaxLimitedCharacter == null ||
        this.requestVector.MaxLimitedCharacter == "" ||
        this.requestVector.MaxLimitedCharacter == undefined
      ) {
        alert("Please fill in the Custom Max Character");
        return;
      }
      try {
        let data = {
          vectordbName: self.searchVectorDBName2,
          MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
          groupReplaceID:
            self.tempgroupReplaceID == null
              ? null
              : JSON.stringify(self.tempgroupReplaceID),
          DetectLanguage: self.requestVector.DetectLanguage,
        };
        self.$call.ReProcessedVector(
          data,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " +
                dataResponse.message;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                backdrop: true,
                customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
              });
              self.GetByVector();
            }
          },
          (errorResource) => {
            console.error(errorResource.message);
          }
        );
      } catch (error) {
        this.LogTrace(error, "ReProcess");
      }
    },
    ReFresh() {
      try {
        let self = this;
        if (
          (self.$route.query.name != null && self.$route.query.name != "") ||
          (self.searchVectorDBName2 != null && self.searchVectorDBName2 != "")
        ) {
          let { page, itemsPerPage } = self.options2;
          self.sortBy = self.options2.sortBy?.[0]?.key || null;
          self.sortDesc = self.options2.sortBy?.[0]?.order === "desc" || false;
          let temp = {
            page: self.isSearch ? 1 : page,
            perPage: itemsPerPage != -1 ? itemsPerPage : null,
            name:
              self.$route.query.name != null
                ? self.$route.query.name
                : self.searchVectorDBName2,
            text_org: self.searchtext_org,
            sortDesc: self.sortDesc,
            sortBy: self.sortBy,
          };
          this.loadingTable = true;
          self.$call.ReFreshVector(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.dataUpdate = dataResponse.data.dataUpdate;
                self.dataAll = dataResponse.data.dataAll;
                self.exceptionFlag = dataResponse.data.exceptionFlag;
                self.searchTotalTable2 = dataResponse.data.table.total;
                self.dataTable2 = dataResponse.data.table.data;
                self.totalTable = dataResponse.data.table.total;
                self.tempgroupReplaceID = dataResponse.data.groupReplaceID;
                self.requestVector.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
                self.requestVector.PersonalInfo = dataResponse.data.personalInformation;
                self.needsReprocessing = dataResponse.data.table.needsReprocessing;
              }
              self.loadingTable = false;
              self.totalTable = self.totalTable + 1;
              self.isSearch2 = false;
              self.isFirst2 = false;
            },
            (errorResource) => {
              self.isSearch2 = false;
              self.loadingTable = false;
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "ReFresh");
      }
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        if (
          (self.$route.query.name != null && self.$route.query.name != "") ||
          (self.searchVectorDBName2 != null && self.searchVectorDBName2 != "")
        ) {
          if (self.dataUpdate == self.dataAll || self.exceptionFlag || (self.dataUpdate <= 0 && self.dataAll <= 0))
          {
            death_waiting = false;
          }
          else 
          {
            this.ReFresh();
          }
          if (window.location.pathname != "/UploadVector")
            death_waiting = false;
        } else if(self.$route.query.name == null) {
          death_waiting = false;
          this.loadingTable = false;
        } else {
          death_waiting = false;
          this.loadingTable = false;
        }
        
        if (death_waiting) {
          await new Promise((resolve) => setTimeout(resolve, 5000));
        }
      } while (death_waiting);
    },
    GetDDGroupReplaceDB() {
      let self = this;
      self.dialog = true;
      const vectordbName = self.$route.query.name || self.searchVectorDBName2;
      self.$call.GetDDGroupReplaceDBForVector(
        vectordbName,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGroupReplace = dataResponse.data == null ? [] : dataResponse.data;
          } else {
            self.DDGroupReplace = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    GetMaxLimitedCharacter() {
      let self = this;
      self.dialog = true;
      self.$call.GetMaxLimitedCharacter(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.requestVector.MaxLimitedCharacter = dataResponse.data;
          } else {
            self.requestVector.MaxLimitedCharacter = null;
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    TemplateVectorDialog() {
      let self = this;
      self.TemplateVector = true;
    },
    ShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTable2.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    CloseShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTable2.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    Search() {
      let self = this;
      self.isSearch2 = true;
      self.options2.page = 1;
      self.ReFresh();
    },
    UpdatePersonalInformation(item) {
      let self = this;
      self.dialog = true;
      var parameter = {
        VectorDBName: item
      }
      self.$call.UpdatePersonalInformation(
        parameter,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.ReFresh();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    getFileIcon(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();
      switch (extension) {
        case 'pdf':
          return this.images.pdfImg || this.images.excelImg;
        case 'doc':
        case 'docx':
          return this.images.wordImg || this.images.excelImg;
        case 'xls':
        case 'xlsx':
          return this.images.excelImg;
        case 'csv':
          return this.images.csvImg || this.images.excelImg;
        case 'txt':
          return this.images.txtImg || this.images.excelImg;
        case 'ppt':
        case 'pptx':
          return this.images.pptImg || this.images.excelImg;
        default:
          return this.images.excelImg;
      }
    },
    deleteSelectedFiles() {
      if (this.selectedFiles.length === 0) return;
      if(this.selectAll && this.selectedFiles.length === this.uploadedFiles.length) {
        this.deleteType = 'all';
      } else {
        this.deleteType = 'individual';
      }
      this.dialog_delete = true;
    },
    deleteSingleFile(fileToDelete) {
      let self = this;
      self.deleteItem = fileToDelete;
      self.deleteType = 'single';
      self.dialog_delete = true;
    },
    confirmDelete() {
      let fileToDelete = this.deleteItem;
      if(fileToDelete == 1) {
        this.dialog_delete = false;
        this.files = [];
        this.uploadedFiles = [];
        this.selectedFiles = [];
        this.selectAll = false;
        this.clearDragDropRef();
        this.requestVector.entity = null;
        return;
      }
      if(this.deleteType == 'all') {
        // Delete all files
        this.uploadedFiles = [];
        this.selectAll = false;
        this.requestVector.entity = null;
        // Clear drag-drop component
        this.clearDragDropRef();
      } else if(this.deleteType == 'individual') {
          this.uploadedFiles = this.uploadedFiles.filter(file => 
            !this.selectedFiles.some(selected => selected.id === file.id)
          );
          
          // Clear selected files
          this.selectedFiles = [];
          
          // Update the entity if no files left
          if (this.uploadedFiles.length === 0) {
            this.requestVector.entity = null;
            this.clearDragDropRef();
          } else {
            this.clearDragDropRef();
            // Update FormData with remaining files
            this.updateFormData();
          }
      } else {
          this.uploadedFiles = this.uploadedFiles.filter(file => file.name !== fileToDelete.name);
              
          // Remove from selected files if it was selected
          this.selectedFiles = this.selectedFiles.filter(file => file.name !== fileToDelete.name);
          
          // Update the entity if no files left
          if (this.uploadedFiles.length === 0) {
            this.requestVector.entity = null;
            this.clearDragDropRef();
          } else {
            this.clearDragDropRef();
            // Update FormData with remaining files
            this.updateFormData();
          }
      }
      
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    updateFormData() {
      if (this.uploadedFiles.length > 0) {
        const formDataDoc = new FormData();
        this.uploadedFiles.forEach(fileWrapper => {
          const file = fileWrapper.originalFile || fileWrapper;
          formDataDoc.append("entity", file);
        });
        
        // Add other form parameters
        formDataDoc.append("vectordbName", this.searchVectorDBName2 || '');
        formDataDoc.append("modelType", this.requestVector.modelType || '');
        formDataDoc.append("deleteAll", this.requestVector.deleteAll || false);
        formDataDoc.append("DetectLanguage", this.requestVector.DetectLanguage || false);
        formDataDoc.append("MaxLimitedCharacter", this.requestVector.MaxLimitedCharacter || 20000);
        
        if (this.requestVector.customCharacter) {
          formDataDoc.append("customCharacter", this.requestVector.customCharacter);
        }
        if (this.tempgroupReplaceID) {
          formDataDoc.append("groupReplaceID", JSON.stringify(this.tempgroupReplaceID));
        }
        if (this.requestVector.PersonalInformation) {
          formDataDoc.append("PersonalInformation", this.requestVector.PersonalInformation);
        }
        
        this.requestVector.entity = formDataDoc;
      } else {
        this.requestVector.entity = null;
      }
    },
    clearDragDropRef() {
      if (this.$refs.dragDropRef) {
        // Clear the component's files array if it exists
        if (this.$refs.dragDropRef.files) {
          this.$refs.dragDropRef.files = [];
        }
        
        // Clear internal files if the component has this property
        if (this.$refs.dragDropRef.uploadedFiles) {
          this.$refs.dragDropRef.uploadedFiles = [];
        }
        
        // Try to call the component's clear method
        if (typeof this.$refs.dragDropRef.clearFiles === 'function') {
          this.$refs.dragDropRef.clearFiles();
        }
        
        // Clear the actual file input
        if (this.$refs.dragDropRef.$el) {
          const fileInputs = this.$refs.dragDropRef.$el.querySelectorAll('input[type="file"]');
          fileInputs.forEach(input => {
            input.value = '';
          });
        }
      }
      
      // Also clear our local files reference
      this.files = [];
    },
  },
  mounted() {
    this.GetDate();
    this.AutoRefresh();
    this.GetDDGroupReplaceDB();

    if (this.$route.query.name) {
      this.searchVectorDBName2 = this.$route.query.name;
      this.showTable = true;
      this.actionEdit = true;
      this.flagNew = false;
      // this.requestVector.modelType = 1;
    } else {
      // this.requestVector.modelType = 1;
      this.dataUpdate = 0;
      this.GetMaxLimitedCharacter();
    }
    if (this.requestVector.MaxLimitedCharacter == null) {
      this.ReFresh();
    }
  },
};
</script>

<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 1.5rem;
  margin-top: 1rem;
  padding: 0.75rem;
}

.flex {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.row + .row {
  margin-top: -20px !important;
}

.icon {
  order: 0;
}

.header {
  order: 1;
  font-weight: 700;
}

.v-expansion-panel-header {
  padding: 0;
}

.text-container {
  display: flex;
  align-items: flex-start;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

.text-content-show {
  overflow: hidden;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

.responsive-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
}

.table-wrapper {
  width: 100%;
  overflow: hidden;
}

.preserve-whitespace {
  white-space: pre;
}

/* Section Wrappers - ลด margin */
.config-wrapper,
.search-wrapper {
  margin-bottom: 20px;
}

/* Section Headers - ลด margin และ padding */
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0 2px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-icon {
  color: white;
  font-size: 20px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin: 0;
}

/* Cards - ลด border radius และ transition */
.config-card,
.search-card {
  border-radius: 8px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  transition: all 0.15s ease;
}

.config-card:hover,
.search-card:hover {
  border-color: rgba(var(--v-theme-primary), 0.2);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.08);
}

.config-content,
.search-content {
  padding: 16px;
}

/* Form Sections - ลด margin */
.form-section {
  margin-bottom: 0px !important;
}

.subsection-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1rem;
  font-weight: 500;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 12px;
}

.subsection-icon {
  color: rgb(var(--v-theme-primary));
  font-size: 18px;
}

.section-divider {
  margin: 10px 0;
  opacity: 0.6;
}

/* Form Rows - ลด padding */
.form-row,
.search-row,
.settings-row {
  margin-bottom: 0;
}

.form-row .v-col,
.search-row .v-col,
.settings-row .v-col {
  padding-top: 6px;
  padding-bottom: 6px;
}

/* Input Wrappers - ลด gap */
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-label {
  font-size: 16px;
  font-weight: 400;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
  line-height: 1.2;
}

/* Help Icons */
.help-icon {
  color: #A6A6A6;
  cursor: help;
  transition: color 0.15s ease;
}

.help-icon:hover {
  color: rgb(var(--v-theme-primary));
}

/* Processing Item */
.processing-item {
  border-radius: 6px;
  margin: 1px 6px;
}

.processing-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.05);
}

.processing-avatar {
  border-radius: 4px;
}

/* Tooltip Images */
.tooltip-image {
  border-radius: 6px;
  overflow: hidden;
}

.tooltip-image img {
  display: block;
  border-radius: 6px;
}

/* Switch Components - ลดขนาด */
.switch-container-LangDetect {
  display: flex;
  align-items: flex-start;
  min-height: 36px;
  min-width: 80px;
  max-width: 300px;
  border-radius: 8px;
  border: 1px solid #0000001e;
}

.language-switch {
  margin: 0;
}

.switch-label-container {
  display: flex;
  align-items: center;
}

.switch-text {
  font-size: 0.8rem;
  color: rgb(var(--v-theme-on-surface));
}
/* tooltip */
.info-tooltip{
  margin-left: 15px!important;
  margin-top: 10px!important;
}
/* Action Section - ลด padding */
.action-section {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  padding-top: 4px;
}

.action-left {
  display: flex;
  align-items: center;
}

.upload-action-wrapper {
  margin-right: 1rem;
  position: relative;
}

/* Style for DragDropFile Component */
.styled-upload-component {
  margin: 0 !important;
  padding: 0 !important;
}

/* Style the upload button inside DragDropFile */
.styled-upload-component :deep(.NoDragDrop .v-btn) {
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 0 24px !important;
  height: 48px !important;
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  text-transform: none !important;
  min-width: 160px !important;
  box-shadow: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
  margin: 0 !important;
}

/* Hover effect for upload button */
.styled-upload-component :deep(.NoDragDrop .v-btn:hover) {
  background: linear-gradient(135deg, #45a049 0%, #4caf50 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
}

/* Animation effect */
.styled-upload-component :deep(.NoDragDrop .v-btn::before) {
  content: "" !important;
  position: absolute !important;
  top: 0 !important;
  left: -100% !important;
  width: 100% !important;
  height: 100% !important;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  ) !important;
  transition: left 0.5s ease !important;
}

.styled-upload-component :deep(.NoDragDrop .v-btn:hover::before) {
  left: 100% !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .upload-action-wrapper {
    margin-left: 0;
    margin-top: 12px;
    display: flex;
    justify-content: center;
  }

  .styled-upload-component :deep(.NoDragDrop .v-btn) {
    width: 100% !important;
    min-width: auto !important;
    height: 44px !important;
    font-size: 0.9rem !important;
  }
}

@media (max-width: 480px) {
  .styled-upload-component :deep(.NoDragDrop .v-btn) {
    height: 40px !important;
    font-size: 0.85rem !important;
    padding: 0 16px !important;
  }
}

/* Action Controls */
.action-controls-uploadvector {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* Buttons - ลดขนาด */

.edit-btn {
  color: rgb(255, 178, 34) !important;
  background: rgb(255, 241, 197) !important;
}
.edit-btn:hover {
  color: white !important;
  background: rgb(255, 178, 34) !important;
}
.info-btn {
  font-family: "JetBrains Mono", monospace;
  font-size: 0.75rem;
  border-radius: 10px;
}

.checkbox-label {
  font-size: 0.8rem;
  color: rgb(var(--v-theme-on-surface));
}

/* Form Field Enhancements */
:deep(.v-field--variant-outlined) {
  border-radius: 6px;
}

:deep(.v-field--variant-outlined .v-field__outline) {
  --v-field-border-opacity: 0.25;
}

:deep(.v-field--variant-outlined.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  --v-field-border-width: 2px;
}

:deep(.v-field--variant-outlined:hover .v-field__outline) {
  --v-field-border-opacity: 0.4;
}

/* Input Focus Effects */
:deep(.v-text-field input),
:deep(.v-select .v-field__input),
:deep(.v-autocomplete .v-field__input) {
  transition: all 0.15s ease;
}

/* Field ขนาดเล็กลง */
:deep(.v-field--density-compact) {
  --v-field-padding-top: 4px;
  --v-field-padding-bottom: 4px;
}

:deep(.v-field--density-compact .v-field__input) {
  min-height: 32px;
  padding-top: 4px;
  padding-bottom: 4px;
}

/* Chip Enhancements */
:deep(.v-chip) {
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.75rem;
  height: 24px;
}

/* Switch ขนาดเล็กลง */
:deep(.v-switch) {
  transform: scale(0.9);
}

/* Tooltip ขนาดเล็กลง */
:deep(.v-tooltip .v-overlay__content) {
  font-size: 0.75rem;
  padding: 4px 8px;
}

/* Responsive Design */
@media (max-width: 960px) {
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .action-section {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .action-controls {
    justify-content: center;
  }

  .config-content,
  .search-content {
    padding: 12px;
  }

  .subsection-title {
    font-size: 0.9rem;
  }

  .section-title {
    font-size: 1.1rem;
  }
}

@media (max-width: 600px) {
  .action-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }

  .template-btn,
  .action-btn-doc,
  .info-btn {
    width: 100%;
    justify-content: center;
    height: 32px;
    font-size: 0.8rem;
  }

  .config-content,
  .search-content {
    padding: 8px;
  }
}

/* Animation - ลดระยะเวลา */
.config-wrapper,
.search-wrapper {
  opacity: 0;
  transform: translateY(10px);
  animation: slideInUp 0.25s ease forwards;
}

.search-wrapper {
  animation-delay: 0.05s;
}

@keyframes slideInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Template Dialog Styles */
.template-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.template-header {
  color: #171717;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #C9C9C9;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  font-size: 32px;
  opacity: 0.9;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  color: #171717;
}

.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
  color: #646464;
}

.close-btn {
  color: #171717 !important;
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.template-content {
  padding: 24px;
}

.template-description {
  margin-bottom: 20px;
}
.custom-alert {
  background: linear-gradient(135deg, #FFF2F2 0%, #FFFFFF 100%);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #C9C9C9;
}
.alert-content {
  font-size: 0.875rem;
}

.template-instructions {
  margin: 8px 0 0 16px;
  padding-left: 10px;
}

.template-instructions li {
  margin: 4px 0;
  line-height: 1.4;
}

.template-table-wrapper {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.template-table {
  background: white;
}

.template-table :deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

.template-table :deep(.v-data-table-header) {
  background-color: #f5f5f5;
}

.template-table :deep(.v-data-table-header th) {
  font-weight: 600;
  color: #424242;
  font-size: 0.875rem;
  border-bottom: 2px solid #e0e0e0;
  padding: 16px 12px;
}

.template-row {
  transition: background-color 0.2s ease;
}

.template-row:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.mode-type-cell {
  padding: 16px 12px;
}

.mode-type-content {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.info-icon {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

.custom-tooltip {
  font-size: 0.8rem;
  line-height: 1.4;
}

.download-cell {
  text-align: center;
  padding: 16px 8px;
}

.excel-buttons {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  margin: 8px 0;
}

.download-btn {
  text-transform: none;
  font-weight: 500;
  font-size: 0.75rem;
  border-radius: 8px;
  min-width: 70px;
  height: 32px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.excel-btn {
  margin-bottom: 4px;
}

.excel-multi-btn {
  font-size: 0.7rem;
  min-width: 75px;
}

.not-available {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
}

.template-actions {
  border-top: 1px solid #C9C9C9;
  padding: 16px 24px;
}

.close-action-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 24px;
  height: 40px;
  min-width: 120px;
}
/* Upload Section */
.upload-section {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
}
.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 24px;
  border: 1px dashed #949AA8;
  border-radius: 16px;
  background: linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  width: 100% !important;
}

.upload-area--ready {
  background: linear-gradient(135deg, rgba(255, 242, 242, 1) 0%, rgba(255, 255, 255, 1) 100%);
  border-color: #F29A8B;
  box-shadow: 0 4px 14px rgba(195, 46, 14, 0.12);
}

.upload-area .upload-content {
  color: #9CA3AF;
}

.upload-area .drag-text,
.upload-area .upload-description span,
.upload-area .choose-file-link {
  color: #9CA3AF;
}

.upload-area .choose-file-link {
  text-decoration-color: #9CA3AF;
}

.upload-area .upload-state-icon {
  opacity: 0.65;
}

.upload-area .upload-state-icon :deep(img) {
  filter: grayscale(1);
}

.upload-area--ready .upload-content,
.upload-area--ready .drag-text,
.upload-area--ready .upload-description span {
  color: #6B1D0D;
}

.upload-area--ready .choose-file-link {
  color: #C32E0E;
  text-decoration-color: #C32E0E;
}

.upload-area--ready .upload-state-icon {
  opacity: 1;
}

.upload-area--ready .upload-state-icon :deep(img) {
  filter: none;
}

.upload-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.upload-area:hover {
  border-color: #D1D5DB;
  box-shadow: 0 6px 15px rgba(209, 213, 219, 0.45);
}

.upload-area--ready:hover {
  border-color: rgba(255, 242, 242, 1);
  box-shadow: 0 6px 15px rgb(251, 236, 236);
}

.upload-area:hover::before {
  opacity: 1;
}
.upload-main-btn {
  position: relative;
  z-index: 2;
  border-radius: 12px !important;
  /* font-weight: 600 !important; */
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  padding: 0 24px !important;
  height: 48px !important;
  background-color: transparent !important;
  border: 1px solid rgba(195, 46, 14, 0.8) !important ;
  color:#C32E0E ;
  transition: all 0.3s ease !important;
}

.upload-main-btn:hover {
  box-shadow: 0 6px 20px rgba(195, 46, 14, 0.35) !important;
  transform: translateY(-1px);
}

.upload-main-btn:active {
  transform: translateY(0);
}
.dashed-divider {
  border-top: 1px dashed rgba(0, 0, 0, 0.4);
}

.customstep-header {
    margin: auto;
    align-items: center;
    justify-content: center;
    width: 70%;
}
.imgsection {
    margin: 5px;
    justify-content: center;
    display: flex;
    border-radius: 5px;
}
/* Different backgrounds by file type */
.bg-csv{
  background: rgba(42, 191, 86, 0.1);
}
.bg-pdf {
  background: rgba(221, 32, 37, 0.1); /* red-400 */
}

.bg-ppt {
  background: rgba(190, 56, 25, 0.1); /* blue-400 */
}

.bg-word {
  background: rgba(56, 89, 208, 0.1); /* blue-500 */
}

.bg-excel {
  background: rgba(15, 120, 62, 0.1); /* green-500 */
}
.bg-multicol{
  background: rgba(15, 120, 62, 0.1);
}
.bg-txt {
  background: rgba(23, 23, 23, 0.1); /* gray-200 */
}
:deep(.customstep-header .v-avatar){
  width: 50px!important;
  height: 50px!important;
  font-size: 18px!important;
}
:deep(.customstep-header .v-avatar.v-theme--light.v-avatar--density-default.v-avatar--variant-flat.v-stepper-item__avatar){
  background: linear-gradient(to right, #C32E0E, #F67760)!important;
}
.savebtn {
  background: linear-gradient(135deg, #C32E0E 0%, #F67760 100%);
  color: white !important;
  min-width: 100px;
  border-radius: 12px;
  height: 40px;
  text-transform: none !important;
}
.backbtn {
  color: #C32E0E !important;
  min-width: 120px;
  border-radius: 12px;
  height: 40px;
  text-transform: none !important;
  border: 1px solid #C32E0E;
}
.upload-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.choose-file-link {
    color: #C32E0E; 
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer!important;
}
.upload-description span {
    font-size: 13px;
    color: #646464; 
}
.hidden-upload {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}
.lang-detect-wrapper {
  background-color: #f0f0f0; /* grey when off */
  border-radius: 12px;
  padding: 16px;
  transition: background-color 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.lang-detect-body{
  display: flex;
  align-items: center;
  gap: 10px;
}
.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
/* Responsive Design */
@media (max-width: 768px) {
  .template-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  .template-header {
    padding: 16px 20px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    font-size: 28px;
  }

  .dialog-title {
    font-size: 1.25rem;
  }

  .dialog-subtitle {
    font-size: 0.8rem;
  }

  .template-content {
    padding: 16px;
  }

  .excel-buttons {
    flex-direction: row;
    gap: 4px;
  }

  .download-btn {
    font-size: 0.7rem;
    min-width: 60px;
    height: 28px;
  }

  .excel-multi-btn {
    font-size: 0.65rem;
    min-width: 65px;
  }

  .template-table :deep(.v-data-table-header th) {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .mode-type-cell,
  .download-cell {
    padding: 12px 6px;
  }
}

@media (max-width: 480px) {
  .template-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dialog-title {
    font-size: 1.1rem;
  }

  .dialog-subtitle {
    font-size: 0.75rem;
  }

  .excel-buttons {
    flex-direction: column;
    gap: 3px;
  }

  .download-btn {
    font-size: 0.65rem;
    min-width: 55px;
    height: 26px;
  }

  .template-instructions {
    font-size: 0.8rem;
  }
}

.actions-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 0.75rem 0.5rem;
  min-width: 140px;
  min-height: 80px;
  justify-content: center;
}

/* Edit Button Styling */
.edit-btn {
  background: rgba(33, 150, 243, 0.1) !important;
  border: 1px solid rgba(33, 150, 243, 0.3) !important;
  width: 40px !important;
  height: 40px !important;
}

.edit-btn:hover {
  background: rgba(33, 150, 243, 0.2) !important;
  border-color: rgba(33, 150, 243, 0.5) !important;
}

.edit-btn .v-icon {
  color: rgb(33, 150, 243) !important;
}

/* Delete Button Styling */
.delete-btn {
  background: rgba(244, 67, 54, 0.1) !important;
  border: 1px solid rgba(244, 67, 54, 0.3) !important;
  width: 40px !important;
  height: 40px !important;
}

.delete-btn:hover {
  background: rgba(244, 67, 54, 0.2) !important;
  border-color: rgba(244, 67, 54, 0.5) !important;
}

.delete-btn .v-icon {
  color: rgb(244, 67, 54) !important;
}

/* Enhanced Switch Container */
.switch-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 0.5rem;
  border-radius: 8px;
  background: rgba(76, 175, 80, 0.05);
  border: 1px solid rgba(76, 175, 80, 0.2);
  transition: all 0.2s ease;
  min-width: 80px;
}
.switch-container:hover {
  background: rgba(76, 175, 80, 0.1);
  border-color: rgba(76, 175, 80, 0.3);
}
.vector-switch {
  margin: 0;
  transform: scale(0.9);
}

.vector-switch :deep(.v-selection-control) {
  min-height: 28px;
}

/* Switch Label */
.switch-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: rgba(var(--v-theme-on-surface), 0.8);
  text-align: center;
  line-height: 1.2;
  transition: color 0.2s ease;
  min-width: 50px;
}
.action-buttons-group {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 4px 6px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}
.action-buttons-group:hover {
  background: rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.action-btn-doc {
  border-radius: 6px !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0 1px;
  opacity: 0.7;
  width: 32px !important;
  height: 32px !important;
}

.action-btn-doc:hover {
  opacity: 1;
  transform: translateY(-1px);
}
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
  transition: background-color 0.2s ease;
}
.action-buttons-group:hover .action-divider {
  background: rgba(0, 0, 0, 0.2);
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(25, 118, 210, 0.02);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Focus states */
.action-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}
@media (max-width: 768px) {
  .actions-container {
    gap: 8px;
    padding: 0.5rem 0.25rem;
    min-width: 120px;
  }

  .switch-container {
    padding: 0.25rem;
    min-width: 70px;
  }

  .switch-label {
    font-size: 0.65rem;
  }

  .action-buttons-group {
    flex-direction: column;
    gap: 2px;
    padding: 4px;
  }

  .action-divider {
    width: 80%;
    height: 1px;
    margin: 2px 0;
  }

  .action-btn {
    width: 28px !important;
    height: 28px !important;
  }

  .vector-switch {
    transform: scale(0.8);
  }
}

@media (max-width: 480px) {
  .actions-container {
    min-width: 100px;
    gap: 6px;
  }

  .switch-container {
    min-width: 60px;
  }

  .switch-label {
    font-size: 0.6rem;
  }
}

.toggle-section {
  display: flex;
  align-items: center;
}

.compact-toggle {
  background: rgba(255, 255, 255, 0.507);
  border-radius: 6px;
  padding: 0.25rem 0.75rem;
  border: 1px solid #e0e0e0a4;
  margin: 0;
  transform: scale(0.85);
}

.toggle-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 0.8rem;
  color: #424242;
}
/* Edit Dialog Styles */
.edit-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.edit-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon {
  font-size: 24px;
  opacity: 0.9;
}

.header-text .dialog-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.header-text .dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
}

.close-btn {
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

.edit-content {
  padding: 24px;
  background-color: #fafafa;
}

.textarea-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.textarea-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
}

.content-textarea {
  background: white;
  border-radius: 8px;
}

.content-textarea :deep(.v-field) {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.content-textarea :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.15);
}

.edit-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.cancel-btn,
.save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 20px;
  height: 40px;
  min-width: 100px;
}

.cancel-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
}

/* .save-btn {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

.save-btn:hover {
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.4);
} */

/* Responsive */
@media (max-width: 768px) {
  .edit-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .edit-header {
    padding: 16px 20px;
  }

  .header-text .dialog-title {
    font-size: 1.1rem;
  }

  .edit-content {
    padding: 16px;
  }

  .edit-actions {
    padding: 12px 16px;
    flex-direction: column;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
    margin: 0;
  }
}

/* Add Dialog Styles */
.add-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.add-header {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-header .header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.add-header .header-icon {
  font-size: 24px;
  opacity: 0.9;
}

.add-header .header-text .dialog-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.add-header .header-text .dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
}

.add-header .close-btn {
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.2s ease;
}

.add-header .close-btn:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

.add-content {
  padding: 24px;
}

.add-content .textarea-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.add-content .textarea-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
}

.add-content .content-textarea {
  background: linear-gradient(90deg, #FFF2F2 -15.8%, #FFF 100%);;
  border-radius: 8px;
}

.add-content .content-textarea :deep(.v-field) {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.add-content .content-textarea :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.15);
}

.add-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.add-actions .cancel-btn,
.add-actions .save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 20px;
  height: 40px;
  min-width: 100px;
}

.add-actions .cancel-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
}

.add-actions .save-btn {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
}

.add-actions .save-btn:hover {
  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

/* Responsive for Add Dialog */
@media (max-width: 768px) {
  .add-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .add-header {
    padding: 16px 20px;
  }

  .add-header .header-text .dialog-title {
    font-size: 1.1rem;
  }

  .add-content {
    padding: 16px;
  }

  .add-actions {
    padding: 12px 16px;
    flex-direction: column;
  }

  .add-actions .cancel-btn,
  .add-actions .save-btn {
    width: 100%;
    margin: 0;
  }
}

@media (max-width: 480px) {
  .add-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px);
  }

  .add-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .add-header .header-text .dialog-title {
    font-size: 1rem;
  }

  .add-header .header-text .dialog-subtitle {
    font-size: 0.8rem;
  }
}
.switch-container-personal {
  display: flex;
  align-items: flex-start;
  min-height: 36px;
  min-width: 80px;
  max-width: 300px;
  border-radius: 8px;
  border: 1px solid rgba(255, 152, 0, 0.2);
  background-color: rgba(255, 248, 225, 0.5);
  transition: all 0.2s ease;
}

.switch-container-personal:hover {
  border-color: rgba(255, 152, 0, 0.4);
  background-color: rgba(255, 248, 225, 0.8);
}

.personal-switch {
  margin: 0;
}

.personal-switch :deep(.v-switch__track) {
  opacity: 0.6;
  background-color: rgba(255, 152, 0, 0.2) !important;
}

.personal-switch :deep(.v-switch__track--checked) {
  background-color: rgba(255, 152, 0, 0.6) !important;
}

.personal-switch .switch-label-container {
  display: flex;
  align-items: center;
}

.personal-switch .switch-text {
  font-weight: 500;
  font-size: 0.8rem;
  color: rgb(var(--v-theme-warning));
}
/* Notification Badge */
.notification-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #ff4757;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  box-shadow: 0 2px 8px rgba(255, 71, 87, 0.4);
  border: 2px solid white;
  animation: pulse 2s infinite;
}
.modern-input :deep(.v-field) {
  border-radius: 12px;
  transition: all 0.2s ease;
}
.modern-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}
.required{
  color: red;
}
.action-divider {
  width: 100%;
  height: 1px;
  margin: 25px 0;
  align-self: center;
  border: 2px dashed rgba(0, 0, 0, 0.12);
}
/* Animations */
@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px rgba(255, 71, 87, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0);
  }
}

.myrandonthing{
  height: 55px;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #C9C9C9;
  padding: 12px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}
.filesize-txt{
  font-size: 13px;
  color: #646464;
}
.filename-txt{
  font-size: 15px;
  font-weight: 600;
  color: #001763;
  max-width: 100%;        /* adjust depending on navbar layout */
  white-space: nowrap;     /* keeps the text on one line */
  overflow: hidden;        /* hides overflowing text */
  text-overflow: ellipsis; /* adds the ... */
  display: inline-block;   /* required for ellipsis to work properly */
  vertical-align: middle;
}


/* Multiple Files Table Styles */
.files-table-container {
  margin-top: 16px;
}

.files-table-card {
  border-radius: 12px;
  overflow: hidden;
  border-color: #c9c9c9;
}

.files-table-header {
  background: var(--Table-header-bg, #FFF2F2);
  display: flex;
  padding: 2px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.files-data-table {
  background-color: white;
}

.file-name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-name {
  font-weight: 500;
  color: #001763;
  font-size: 14px;
}

.file-size {
  font-size: 13px;
  color: #646464;
  font-weight: 500;
}

:deep.files-data-table .v-data-table__tr {
  border-bottom: 1px solid #f0f0f0;
  height: 55px !important;
}

.files-data-table .v-data-table__tr:hover {
  background-color: #f8f9fa;
}

.files-data-table .v-data-table-header {
  background-color: #fafafa;
  font-weight: 600;
}

.files-data-table .v-data-table-header th {
  color: #333;
  font-size: 13px;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
}

.files-data-table .v-checkbox {
  justify-content: center;
}

:deep(.custom-checkbox .v-selection-control .v-label) {
  font-weight: 500 !important;
}

:deep(.custom-checkbox .v-selection-control__input .v-icon) {
  color: #C32E0E !important;
}

:deep(.custom-checkbox .v-selection-control__input input:checked + .v-icon) {
  background-color: #C32E0E !important;
  border-color: #C32E0E !important;
}

.template-item {
  transition: all 0.2s ease-in-out;
  border-radius: 6px;
  margin: 2px 4px;
}

.template-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.08);
  transform: translateX(4px);
}

/* Table improvements */
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

:deep(.v-data-table tbody tr) {
  transition: background-color 0.2s ease;
}

:deep(.v-data-table tbody tr:hover) {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

:deep(.v-data-table-header) {
  background: rgba(0, 0, 0, 0.02);
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.7) !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.025em !important;
}
.white-svg {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  filter: brightness(0) invert(1);
}
</style>
